"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SellClientModel = void 0;
var loader_1 = require("./loader");
var SellClientModel = (function () {
    function SellClientModel() {
    }
    SellClientModel.prototype.Init = function () {
        var _this = this;
        this.Form = document.getElementById('form-sell');
        var inputs = this.Form.querySelectorAll('input[name="EnergyType"][type="radio"]');
        for (var i = 0; i < inputs.length; i++) {
            inputs[i].addEventListener('change', function (e) { return _this.changeType(e); });
        }
        $('a.tab-button').on('click touch', function (e) { return _this.navigate(e); });
        this.Form.addEventListener('submit', function (e) { return _this.onSubmit(e); });
    };
    SellClientModel.prototype.changeType = function (e) {
        this.Form.setAttribute('data-type', (e.target).value);
    };
    SellClientModel.prototype.navigate = function (e) {
        e.preventDefault();
        var href = e.currentTarget.getAttribute('href');
        var target = document.querySelector('#tab-header a[href="' + href + '"]');
        if (!e.currentTarget.classList.contains('tab-button-previous')) {
            var inputs = $('input:visible,select:visible');
            if (inputs.length > 0) {
                var valid = inputs.valid();
                if (!valid)
                    return;
            }
        }
        $(target).tab('show');
    };
    SellClientModel.prototype.onSubmit = function (e) {
        var nextButton = $('a.tab-button:visible:not(.tab-button-previous)');
        if (nextButton.length > 0) {
            e.preventDefault();
            nextButton.click();
        }
    };
    return SellClientModel;
}());
exports.SellClientModel = SellClientModel;
(0, loader_1.InitClientContext)(SellClientModel);
